import axios from "axios";

export default {
  namespaced: true,
  state: {
    assets: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    assetsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    RECEIVED_ASSETS(state, payload) {
      state.assets = payload;
      state.isReceiving = false;
    },
    RECEIVING_ASSETS(state) {
      state.isReceiving = true;
    },
    RECEIVED_ASSET(state, payload) {
      console.log("RECEIVED ASSET", payload);
      state = Object.assign(state, {
        assets: [...state.assets, payload],
        isReceiving: false,
      })
    },
    RECEIVING_ASSET(state) {
      state.isReceiving = true;
    },
    UPDATED_ASSET(state, payload) {
      console.log(state.assets);
      console.log(payload);
      let index = state.assets.findIndex(asset => asset._id === payload._id);
      state = Object.assign(state, {
        assets: state.assets.map((asset, i) => {
          if (i === index) {
            return Object.assign({}, asset, payload);
          }
          return asset;
        }),
        isUpdating: false,
        assetsMessage: 'Assets has been updating!',
      })
    },
    UPDATING_ASSET(state) {
      state.isUpdating = true;
    },
    DELETED_ASSET(state, payload) {
      console.log("DELETE", payload);
      let indexToDelete = state.assets.findIndex(asset => asset._id === payload._id);
      console.log(indexToDelete);
      let assets = [...state.assets];
      assets.splice(indexToDelete, 1);
      state = Object.assign(state, {
        assets: [...assets],
        isDeleting: false,
        idToDelete: null,
        assetsMessage: 'Asset has been Deleted!',
      });
    },
    DELETING_ASSET(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deleteAssetRequest({dispatch}, payload) {
      dispatch("deletingAsset", payload);
      var token = localStorage.getItem('token')
      var url = 'https://api.tradexc.com:3000/delete/asset/' + payload._id;
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var del = {
        method: "delete",
        url: url,
        headers: header,
      };

      axios(del)
      .then(function (response) {
        console.log(response.data);
        dispatch("deleteAsset", {_id: payload._id});
      })
      .catch(function (error) {
        console.log(error.data);
      });
    },
    async deleteAssetItemRequest({dispatch}, payload) {
      try{
        dispatch("deletingAsset", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/assetitem/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteAsset", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteAssetListRequest({dispatch}, payload) {
      try{
        dispatch("deletingAsset", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/assetlist/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteAsset", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteAssetImageRequest({dispatch}, payload) {
      try{
        dispatch("deletingAsset", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/assetimage/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteAsset", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getAssetsRequest({dispatch}) {
      dispatch("receivingAssets");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/assets';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: headers})
      .then(res => {
        dispatch("receiveAssets", res.data);
      })
    },
    async insertAssetItemRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/assetitem/' + payload.assetid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        console.log(response.data)
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertAssetItemWithImageRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let url = 'https://api.tradexc.com:3000/insert/assetitem/withimage/' + payload.assetid;
        let data = new FormData();
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
        data.append('file', payload.imagefile, payload.imagename); 
        delete payload['imagefile'];
        for (let x in payload) data.append(x, payload[x]);
        let response = await axios({method: "post", url: url, headers: headers , data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertAssetListRequest({dispatch}, payload) {
      try{
        dispatch("receivingAsset");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/assetlist/' + payload.assetid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertAssetImageRequest({dispatch}, payload) {
      let url;
      let data;
      console.log(payload)
      try{
        dispatch("receivingAsset");
        if(payload.imagefile!=null){
          url = 'https://api.tradexc.com:3000/insert/assetimage/withimage/' + payload.assetid;
          data = new FormData();
          data.append('file', payload.imagefile, payload.imagefilename); 
          delete payload['imagefile'];
          for (let x in payload) {
            data.append(x, payload[x]);
          }
        }
        else{
          data = payload;
          url = 'https://api.tradexc.com:3000/insert/assetimage/' + payload.assetid;
        }
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let response = await axios({method: "POST", url: url, headers: headers, data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateAssetRequest({dispatch}, payload) {
      dispatch("updatingAsset");
      var id = payload._id;
      delete payload['_id'];
      console.log(id, payload);


      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/update/asset/' + id;
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var put = {
        method: "put",
        url: url,
        headers: header,
        data: payload,
      };

      axios(put)
      .then(function (res) {
        console.log(res);
        dispatch("updateAsset", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async updateAssetImageRequest({dispatch}, payload) {
      let url;
      let data;
      console.log(payload);
      try{
        dispatch("updatingAsset");
        if(payload.imagefile!=null){
          url = 'https://api.tradexc.com:3000/update/assetimage/withimage/' + payload.assetimageid;
          data = new FormData();
          data.append('file', payload.imagefile, payload.imagefilename); 
          delete payload['imagefile'];
          for (let x in payload) {
            data.append(x, payload[x]);
          }
        }
        else{
          data = payload;
          url = 'https://api.tradexc.com:3000/update/assetimage/' + payload.assetimageid;
        }
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        console.log(url)
        let response = await axios({method: "PUT", url: url, headers: headers, data: data});
        dispatch("updateAsset", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    createAssetRequest({dispatch}, payload) {
      console.log(payload);
      dispatch("receivingAssets");
      var url;
      var data;
      var header;
      var token = localStorage.getItem('token');
      url = 'https://api.tradexc.com:3000/insert/asset';
      data = payload;
      header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };
      axios(post)
      .then((response)=> {
        console.log(response.data);
        dispatch("receiveAsset", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    async updateAssetListRequest({dispatch}, payload) {
      try{
        dispatch("receivingAsset");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/assetlist/' + payload.assetlistid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receiveAsset", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateAssetItemRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/assetitem/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateAssetItemWithImageRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/assetitem/withimage/' + id;
        let data = new FormData();  
        data.append('file', payload.imagefile, payload.imagename); 
        delete payload['imagefile'];
        for (let x in payload) data.append(x, payload[x]);
        let response = await axios({method: "PUT", url: url, headers: headers, data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveAssets({commit}, payload) {
      commit("RECEIVED_ASSETS", payload)
    },
    receivingAssets({commit}) {
      commit("RECEIVING_ASSETS")
    },
    receiveAsset({commit}, payload) {
      commit("RECEIVED_ASSET", payload)
    },
    receivingAsset({commit}) {
      commit("RECEIVING_ASSET")
    },
    updateAsset({commit}, payload) {
      commit("UPDATED_ASSET", payload)
    },
    updatingAsset({commit}) {
      commit("UPDATING_ASSET")
    },
    deleteAsset({commit}, payload) {
      console.log(payload);
      commit("DELETED_ASSET", payload)
    },
    deletingAsset({commit}, payload) {
      commit("DELETING_ASSET", payload)
    }
  },
};
